export enum MAIN_NAVIGATION_LINK_TYPE {
    MegaMenu = "MegaMenu",
    CascadingMenu = "CascadingMenu",
    Link = "Link",
    CustomLinkList = "CustomLinkList",
}

export enum MAIN_NAVIGATION_DESTINATION_TYPE {
    Url = "Url",
    Page = "Page",
    Category = "Category",
}
